import React, { useState, useEffect } from 'react';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CommonClasses from 'Styles/Common.module.css';
import TutorClasses from '../../Categories/addCategory/index.module.css';
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import { Services } from 'Services';
import ReactLoading from 'react-loading';
import { BsCloudUpload } from 'react-icons/bs';
import GiftClasses from '../../gifts/Gifts.module.css';
import { Success, Error } from 'Util/Toast';
import { useFileUpload } from 'Util/fileUpload';


const EditTemplate = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { template } = state || {};
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(template?.Template || '');
    const [imagePreview, setImagePreview] = useState(template?.Template || '');
    const [templateCategories, setTemplateCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(true);

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    // Fetch template categories on component mount
    useEffect(() => {
        const fetchTemplateCategories = async () => {
            try {
                const token = { Authorization: `token ${localStorage.getItem('token')}` };
                const response = await Services.getTemplateCategories("POST", null, token);
                if (response.Status === 1) {
                    setTemplateCategories(response.TemplateCategories);
                }
                setCategoriesLoading(false);
            } catch (error) {
                console.error('Error fetching template categories:', error);
                setCategoriesLoading(false);
            }
        };

        fetchTemplateCategories();
    }, []);

    useEffect(() => {
        if (template && templateCategories.length > 0) {
            setValue('TemplateName', template.TemplateName);
            setValue('TemplateStatus', template.TemplateStatus);
            setValue('TemplateCategoryID', template.TemplateCategoryID || '');
            setImage(template.Template);
        }
    }, [template, templateCategories, setValue]);

    const { uploadWithLoading } = useFileUpload({
        allowedTypes: ["image/png", "image/jpeg", "image/webp"],
        maxSizeInMB: 10,
        folder: "Templates"
    });


    const filehandleChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        try {
            await uploadWithLoading(
                file,
                (uploadedFile) => {
                    // Success callback
                    setImage(uploadedFile.fileUrl); // Full URL for preview
                    setImagePreview(URL.createObjectURL(file)); // Blob URL for preview
                    setValue('Template', uploadedFile.fileName); // Store just filename for API
                },
                (error) => {
                    console.error("Upload Error:", error);
                }
            );
        } finally {
            setLoading(false);
        }
    };


    const onSubmit = async (body) => {
        setLoading(true);
        try {
            // Extract filename from image
            const filename = image.split('/').pop();
            // Add filename to data
            body.image = filename;
            body.TemplateID = template.TemplateID;

            const token = { Authorization: `token ${localStorage.getItem('token')}` };
            const response = await Services.updateTemplate(body.TemplateID, "PUT", JSON.stringify(body), token);
            if (response.Status === 1) {
                // Template updated successfully
                setLoading(false);
                // Redirect to a different page or perform any other action
                navigate('/templates');
                Success(response.Message);
            } else {
                // Handle error
                setLoading(false);
                Error(response.Message);
            }
        } catch (error) {
            console.error('Error updating template:', error);
            setLoading(false);
            Error('Error updating template');
        }
    };

    const fileuploadDesign = (
        <div className={TutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={TutorClasses['upload-image']}>
                {imagePreview && <img src={imagePreview} alt="Selected" className={TutorClasses['uploaded-coupon-image']} />}
                {!imagePreview && (
                    <div className={TutorClasses['add-item']} onClick={() => document.getElementById("image").click()}>
                        <BsCloudUpload className={TutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={filehandleChange} style={{ display: 'none' }} />
            </div>
        </div>
    );

    return (
        <Layout Active={'Templates'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Update Templates</title>
            </Helmet>
            <div className={CommonClasses['Container']}>
                <div className={CommonClasses["control-btns"]}>
                    <button className={CommonClasses["button"]} onClick={() => navigate(-1)}>Back</button>
                </div>
                <div className={TutorClasses['wrapper']} data-aos="zoom-in-down">
                    <h2 className={TutorClasses['main-header']}>Update Template</h2>
                    <form className={TutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="TemplateName">Template Name</label>
                            <input type='text' {...register('TemplateName', { required: 'Please enter a template name.' })} />
                            {errors.TemplateName && <p className={GiftClasses["error-message"]}>{errors.TemplateName.message}</p>}
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="TemplateCategoryID">Template Category <span className="important">*</span></label>
                            <select
                                {...register('TemplateCategoryID', { required: 'Please select a template category.' })}
                                disabled={categoriesLoading}
                                defaultValue={template?.TemplateCategoryID || ''}
                            >
                                <option value="">Select Template Category</option>
                                {templateCategories.map((category) => (
                                    <option key={category.TemplateCategoryId} value={category.TemplateCategoryId}>
                                        {category.TemplateCategoryName}
                                    </option>
                                ))}
                            </select>
                            {errors.TemplateCategoryID && <p className={GiftClasses["error-message"]}>{errors.TemplateCategoryID.message}</p>}
                        </div>

                        <div className={TutorClasses['form-control']}>
                            <label htmlFor="TemplateStatus">Template Status</label>
                            <select {...register('TemplateStatus', { required: 'Please select a template status.' })}>
                                <option value="">Select Template Status</option>
                                <option value="1">Active</option>
                                <option value="2">InActive</option>
                            </select>
                            {errors.TemplateStatus && <p className={GiftClasses["error-message"]}>{errors.TemplateStatus.message}</p>}
                        </div>

                        <div className={TutorClasses['file-upload-wrapper']}>
                            <header>
                                <h3>
                                    Upload Image <span className="important">*</span>
                                </h3>
                            </header>
                            <div className={TutorClasses["upload-image"]} required>
                                {fileuploadDesign}
                            </div>
                        </div>
                        {/* Add more input fields for other properties */}
                        <button disabled={loading}>
                            {loading ? (
                                <ReactLoading color="green" type="spokes" height={30} width={30} />
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default EditTemplate;
